var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.auth)?_c('Nav'):_vm._e(),_c('router-view',{class:[
      'router-view',
      {
        'router-body': _vm.auth
      }
    ]}),(_vm.load)?_c('Loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }